import React from 'react';
import analyticsImage from '../../assets/landing-analytics.png';

const previewRows = [
  ['Metric Cards', 'Calculated after upload'],
  ['Charts', 'Built from detected columns'],
  ['Ask GabMic', 'Answered from real rows'],
];

const AnalyticsPreview: React.FC = () => {
  return (
    <section id="analytics" style={{ padding: '8rem 0', backgroundColor: 'var(--bg-surface)', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '3rem', alignItems: 'center' }}>
          <div>
            <span className="mono-label">Analytics Page</span>
            <h2>Simple enough to use. Serious enough to trust.</h2>
            <p>
              GabMic adapts to sales, financial, marketing, and general business data. It looks for totals, averages, trends, comparisons, patterns, and unusual changes without forcing every business into one industry model.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <img
              src={analyticsImage}
              alt="Business spreadsheet data turning into analytics charts"
              style={{
                width: '100%',
                aspectRatio: '16 / 9',
                objectFit: 'cover',
                borderRadius: '8px',
                border: '1px solid var(--border-color)',
              }}
            />

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.75rem', marginBottom: '1rem' }}>
              {previewRows.map(([label, value]) => (
                <div key={label} style={{ border: '1px solid var(--border-color)', borderRadius: '6px', padding: '0.85rem' }}>
                  <span className="mono-label" style={{ marginBottom: '0.35rem' }}>{label}</span>
                  <small style={{ color: 'var(--text-secondary)' }}>{value}</small>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsPreview;
